module.exports = __webpack_public_path__ + "9667dfaae8922fdaaa710750b24b49b8.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/dan-gebhardt.jpg
// module id = 438
// module chunks = 0